export const STATUS_OPTIONS = [
  { value: 'PENDING', label: 'Pendente' },
  { value: 'CONFIRMED', label: 'Confirmada' },
  { value: 'CANCELLED', label: 'Cancelada' },
];

export const initialValues = {
  name: '',
  room_id: '',
  tenant_id: '',
  user_id: '',
  start_date: '',
  end_date: '',
  status: 'PENDING',
};